export default __webpack_public_path__ + "static/1430-a62549fe24c50594837d773045c5b0e4.gif";